export enum ColType {
	small,
	normal,
	big,
	extraBig,
	currency,
}

export interface Total {
	id?: string;
	month?: string;
	value: string;
}

export interface HeadersWithDescription {
	text?: string;
	description: string;
}

export enum TableAppearance {
	primary,
	withoutHeader,
	withLevels,
	withAccordion,
	withAccordionGrey,
	withInputs,
}

export interface TableColumn {
	value?: any;
}

export interface Row {
	id: string;
	image?: string;
	mobileImage?: string;
	columns?: TableColumn[];
	subRows?: TableSubRow[];
	isGreen?: boolean;
	isBold?: boolean;
	isSelected?: boolean;
	isCollapsed?: boolean;
	isDownloadable?: boolean;
}

export interface TableSubRow {
	id: string;
	columns?: TableColumn[];
	subSubRows?: TableSubSubRow[];
	isGreen?: boolean;
	isBold?: boolean;
	isSelected?: boolean;
	isCollapsed?: boolean;
}
export interface TableSubSubRow {
	id: string;
	columns?: TableColumn[];
}
